import * as C from "../constants";

import { get_orders, get_encashments, get_machines_addresses, get_keys_transactions } from "utils/http";
import { parseJSON } from "utils/misc";

import { logout } from "./auth";
import { history } from "../history";

export function getOrdersRequest() {
    return {
        type: C.GET_ORDERS_REQUEST
    }
}

export function getOrdersFailure() {
    return {
        type: C.GET_ORDERS_FAILURE,
    }
}

export function getOrdersSuccess(data) {
    return {
        type: C.GET_ORDERS_SUCCESS,
        payload: data,
    }
}

export function getEncashmentsRequest() {
    return {
        type: C.GET_ENCASHMENTS_REQUEST,
    }
}

export function getEncashmentsFailure() {
    return {
        type: C.GET_ENCASHMENTS_FAILURE,
    }
}

export function getEncashmentsSuccess(data) {
    return {
        type: C.GET_ENCASHMENTS_SUCCESS,
        payload: data,
    }
}

export function getOrdersMachinesRequest() {
    return {
        type: C.GET_ORDERS_MACHINES_REQUEST
    }
}

export function getOrdersMachinesFailure() {
    return {
        type: C.GET_ORDERS_MACHINES_FAILURE
    }
}

export function getOrdersMachinesSuccess(data) {
    return {
        type: C.GET_ORDERS_MACHINES_SUCCESS,
        payload: data,
    }
}

export function getKeysTransactionsRequest() {
    return {
        type: C.GET_KEYS_TRANSACTIONS_REQUEST
    }
}

export function getKeysTransactionsFailure() {
    return {
        type: C.GET_KEYS_TRANSACTIONS_FAILURE
    }
}

export function getKeysTransactionsSuccess(data) {
    return {
        type: C.GET_KEYS_TRANSACTIONS_SUCCESS,
        payload: data,
    }
}

export function getOrders(token, page,  rowsPerPage, fromTime, toTime, payment_type, order_by, desc) {
    return function (dispatch) {
        dispatch(getOrdersRequest());
        return get_orders(token, page, rowsPerPage, fromTime, toTime, payment_type, order_by, desc)
            .then(parseJSON).then(response => {
                dispatch(getOrdersSuccess(response))
            }).catch(error => {
                dispatch(getOrdersFailure());
                if (error.response && error.response.status === 401) {
                    dispatch(logout());
                    history.replace("/login");
                }
            })
    }
}

export function getEncashments(token, page,  rowsPerPage, fromTime, toTime, machines, order_by, desc) {
    return function (dispatch) {
        dispatch(getEncashmentsRequest());
        return get_encashments(token, page,  rowsPerPage, fromTime, toTime, machines, order_by, desc)
            .then(parseJSON).then(response => {
                dispatch(getEncashmentsSuccess(response))
            }).catch(error => {
                dispatch(getEncashmentsFailure());
                if (error.response && error.response.status === 401) {
                    dispatch(logout());
                    history.replace("/login");
                }
            })
    }
}

export function getOrdersMachines(token) {
    return function (dispatch) {
        dispatch(getOrdersMachinesRequest());
        return get_machines_addresses(token)
            .then(parseJSON).then(response => {
                dispatch(getOrdersMachinesSuccess(response))
            }).catch(error => {
                dispatch(getOrdersMachinesFailure());
                if (error.response && error.response.status === 401) {
                    dispatch(logout());
                    history.replace("/login");
                }
            })
    }
}

export function getKeysTransactions(token, page, rows_per_page, from_time, to_time, order_by, desc, search_query) {
    return function (dispatch) {
        dispatch(getKeysTransactionsRequest());
        return get_keys_transactions(token, page, rows_per_page, from_time, to_time, order_by, desc, search_query)
            .then(parseJSON).then(response => {
                dispatch(getKeysTransactionsSuccess(response))
            }).catch(error => {
                dispatch(getKeysTransactionsFailure());
                if (error.response && error.response.status === 401) {
                    dispatch(logout());
                    history.replace("/login");
                }
            })
    }
}


// WEBPACK FOOTER //
// ./src/actions/orders.js